import * as merx_namespace from './namespaces/MERX.json';
import * as bjc_namespace from './namespaces/BJC.json';
import * as ssc_namespace from './namespaces/SSC.json';
import * as default_namespace from './namespaces/DEFAULT.json';

export default {
    'DEFAULT': default_namespace,
    'MERX': merx_namespace,
    'BJC': bjc_namespace,
    'SSC': ssc_namespace
}